import { EgretLoadable } from "egret";

const settings = {
  activeLayout: "layout1",
  layout1Settings: {
    topbar: {
      show: false,
      showcontent: true,
      backgroudColor: "#ececec",
    },
    navbar: { show: false },
    leftSidebar: {
      show: true,
      mode: "compact",
    },
  },
  layout2Settings: {
    mode: "full",
    topbar: {
      show: false,
    },
    navbar: { show: false },
  },
  secondarySidebar: { show: false },
  footer: { show: false },
};

// Lazy-load like every other route: a direct import pulls shared component
// CSS (Text, Table...) into the main bundle ahead of Material-UI's styles,
// which then override font sizes app-wide.
const CountersDashboard = EgretLoadable({
  loader: () => import("./index"),
});

const countersDashboardRoutes = [
  {
    path: "/counters-dashboard",
    component: CountersDashboard,
    settings,
  },
];

export default countersDashboardRoutes;
